export default __webpack_public_path__ + "static/media/30.e16ce3a6.png";